export const HERMES_DATA_FIXES_FLAG = 'hermes.dataFixes'
export const HERMES_DATA_FIXES_QUERY_DIAGNOSTICS_FLAG =
  'hermes.dataFixesQueryDiagnostics'
